
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/easilydo-mail",
      function () {
        return require("private-next-pages/android/local/easilydo-mail/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/easilydo-mail"])
      });
    }
  